import React from 'react'
import { Menu } from '@lmc/ui-kit'
import styled from 'styled-components'
import { ConfigProvider } from 'antd'
import {
  CustomMenuItemType,
  getNavigationMenuItems,
  navigationTheme,
} from 'utils'

type SettingsSidebarNavigationProps = {
  menuItems: CustomMenuItemType[]
  navigate: (key: string) => void
  navigationKey: string
}

const SettingsSidebarNavigation: React.FC<SettingsSidebarNavigationProps> = ({
  menuItems,
  navigate,
  navigationKey,
}) => {
  const items = getNavigationMenuItems(menuItems)

  return (
    <StyledContainer>
      <StyledMenuContainer>
        <ConfigProvider theme={navigationTheme}>
          <Menu
            onClick={({ key }) => navigate(`${key}`)}
            style={{ border: 'none' }}
            selectedKeys={[navigationKey]}
            mode="inline"
            theme="light"
            inlineCollapsed={false}
            items={items}
          />
        </ConfigProvider>
      </StyledMenuContainer>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  margin-bottom: 0px;
  background-color: ${(props) => props.theme.color?.neutral.color11} !important;
  max-width: 290px;
  width: 100%;
  height: 100%;
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    margin-right: 24px;
    margin-left: 24px;
    max-width: unset;
    width: 100%;
  }
`

const StyledMenuContainer = styled.div`
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    max-height: unset;
  }
`

export default SettingsSidebarNavigation
